/*
 * @Author: your name
 * @Date: 2020-11-19 20:40:54
 * @LastEditTime: 2022-11-15 09:53:48
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/utils/navigator.js
 */

const mainNavigatorList = [
  'chrome',
  'firefox',
  'safari',
  'opera'
]

function _isMainNavigator(mainNavigator) {
  const navigatorString = window.navigator.userAgent.toLowerCase()
  return !_isAppBrowser() && navigatorString.includes(mainNavigator.toLowerCase())
}

function _isAppBrowser() {
  const ua = window.navigator.userAgent.toLowerCase()
  return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1) || ua.includes('Instagram') || ua.includes('instagram')
}

function _isIncludesMainNavigator() {
  return mainNavigatorList.some(nav => _isMainNavigator(nav))
}

function isIOS() {
  var u = navigator.userAgent
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // IOS terminal   // ios 终端
  return isiOS
}

function isAndroid() {
  const u = navigator.userAgent
  const res = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // IOS terminal   // ios 终端
  const isAndroid = !res
  return isAndroid
}

export {
  _isIncludesMainNavigator,
  isIOS,
  isAndroid,
}
